import React, { FC, useEffect, useRef } from 'react';
import { type HeadFC, type PageProps } from 'gatsby';
import LandingPage from '../components/landing';
import Header from '../components/header';
import AboutUs from '../components/about-us';
import Services from '../components/services';
import Temp from '../components/temp';
import Team from '../components/team';
import Location from '../components/location';
import Footer from '../components/footer';
import firebase from '../utilities/firebase';
import '../styles/index.scss';
import '../styles/animations.scss';
import Seo from '../components/seo';

const IndexPage: FC<PageProps> = () => {
  const headerRef = useRef<HTMLDivElement>(null);
  const landingRef = useRef<HTMLDivElement>(null);
  const aboutRef = useRef<HTMLDivElement>(null);
  const servicesRef = useRef<HTMLDivElement>(null);
  const teamRef = useRef<HTMLDivElement>(null);
  const locationRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    firebase;
  });

  const handleNavigateLink = (id: string) => {
    const main = document.querySelector('main');
    const isMobile = window.innerWidth < 720;
    if (main) {
      switch (id) {
        case 'landing':
          main.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        case 'about':
          if (aboutRef.current) {
            main.scrollTo({
              top: isMobile
                ? aboutRef.current.offsetTop - 72
                : aboutRef.current.offsetTop - 109,
              behavior: 'smooth',
            });
          }
          return;
        case 'services':
          if (servicesRef.current) {
            main.scrollTo({
              top: isMobile
                ? servicesRef.current.offsetTop - 72
                : servicesRef.current.offsetTop - 109,
              behavior: 'smooth',
            });
          }
          return;
        case 'team':
          if (teamRef.current) {
            main.scrollTo({
              top: isMobile
                ? teamRef.current.offsetTop - 72
                : teamRef.current.offsetTop - 109,
              behavior: 'smooth',
            });
          }
          return;
        case 'location':
          if (locationRef.current) {
            main.scrollTo({
              top: isMobile
                ? locationRef.current.offsetTop - 72
                : locationRef.current.offsetTop - 109,
              behavior: 'smooth',
            });
          }
          return;
        default:
          return;
      }
    }
  };

  return (
    <main id='main'>
      {/* <Temp /> */}
      <Header ref={headerRef} handleNavigateLink={handleNavigateLink} />
      <LandingPage ref={landingRef} handleNavigateLink={handleNavigateLink} />
      <AboutUs ref={aboutRef} />
      <Services ref={servicesRef} />
      <Team ref={teamRef} />
      <Location ref={locationRef} />
      <Footer />
    </main>
  );
};

export default IndexPage;

export const Head: HeadFC = () => <Seo></Seo>;
